const Currency = {
  'ko': {
    currency: {
      style: 'currency', currency: 'KRW'
    }
  },
  'en': {
    currency: {
      style: 'currency', currency: 'USD'
    }
  },
  'ja': {
    currency: {
      style: 'currency', currency: 'JPY'
    }
  },
  'zh-cn': {
    currency: {
      style: 'currency', currency: 'CNY'
    }
  },
  'zh-tw': {
    currency: {
      style: 'currency', currency: 'CNY'
    }
  }
};

export default Currency;
